import React from 'react';
import EmptyNoBoards from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/empty/components/empty-no-boards/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { BOARDS_TAB_KEY, EMPTY_STATE } from '../../../../common/constants/tab-content.tsx';
import TabEmptyState from '../../../../common/ui/empty-state/index.tsx';
import {
	EndInteractionsTracker,
	useFireErrorOrSuccessAnalytics,
} from '../../../../common/utils.tsx';
import messages from './messages.tsx';

export const EmptyState = ({ isSearch = false }) => {
	const { formatMessage } = useIntl();
	const imageProps = {
		renderImage: getAkEmptyStateRenderImageFn(EmptyNoBoards),
	};

	useFireErrorOrSuccessAnalytics(false, null, false, BOARDS_TAB_KEY);

	return (
		<>
			<TabEmptyState
				{...imageProps}
				header={formatMessage(isSearch ? messages.emptySearchHeader : messages.emptyStateHeader)}
				headingLevel={2}
				description={!isSearch && formatMessage(messages.emptyStateDescription)}
				secondaryAction={<></>}
			/>
			<EndInteractionsTracker transitionKey={BOARDS_TAB_KEY} renderState={EMPTY_STATE} />
		</>
	);
};
